import { Component, inject, Input, OnInit } from '@angular/core'
import { Store } from '@ngxs/store'
import { Router } from '@angular/router'
import { IUser, Logout, ReferralType, UserAccountState } from '@mg-platform/users/users-data-access'
import { Observable } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { IHeaderRouteInfo } from '../main-header/main-header.interface'
import { StateResetAll } from 'ngxs-reset-plugin'

@UntilDestroy()
@Component({
  selector: 'mg-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: false
})
export class SideMenuComponent implements OnInit {
  @Input() forAdminPanel = false
  @Input() mainMenuRoutes: IHeaderRouteInfo[]
  currentUser$: Observable<IUser> = inject(Store).select(UserAccountState.currentUser)
  currentUser: IUser

  referralType = ReferralType

  constructor(
    private store: Store,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentUser$.pipe(untilDestroyed(this)).subscribe((res) => {
      this.currentUser = res
    })
  }

  logout() {
    this.store.dispatch(new Logout()).subscribe(() => {
      this.router.navigateByUrl('/login')
      this.store.dispatch(new StateResetAll())
    })
  }
}
